export const LiquidationOtherProductsTypes = {
  GET_LIQUIDATION_OTHER_PRODUCTS: "GET_LIQUIDATION_OTHER_PRODUCTS",
  GET_OTHER_NOTES: "GET_OTHER_NOTES",
  GET_OTHER_PRODUCTS: "GET_OTHER_PRODUCTS",
  CLEAR_LIQUIDATION_OTHER_PRODUCTS: "CLEAR_LIQUIDATION_OTHER_PRODUCTS",
  SEARCH_INPUTS_LIQUIDATION_OTHER_PRODUCTS: "SEARCH_INPUTS_LIQUIDATION_OTHER_PRODUCTS",
  SELECT_INPUTS_LIQUIDATION_OTHER_PRODUCTS: "SELECT_INPUTS_LIQUIDATION_OTHER_PRODUCTS",
  ADD_LIQUIDATION_OTHER_PRODUCT: "ADD_LIQUIDATION_OTHER_PRODUCT",
  EDIT_LIQUIDATION_OTHER_PRODUCT: "EDIT_LIQUIDATION_OTHER_PRODUCT",
  DELETE_LIQUIDATION_OTHER_PRODUCT: "DELETE_LIQUIDATION_OTHER_PRODUCT",
  CLEAR_SETTLED_NOTES: "CLEAR_SETTLED_NOTES",
  RESTORE_INITIAL_LIQUIDATION_OTHER_PRODUCTS: "RESTORE_INITIAL_LIQUIDATION_OTHER_PRODUCTS",
};
